<template>
	<div class="c-empty flex-column flex-center" :style="{'height': height}">
		<div class="c-empty-icon">
			<img :src="config.icon" />
		</div>
		<div class="c-empty-message">{{config.message}}</div>
	</div>
</template>

<script>
	export default {
		props: {
			type: String,
			height: String,
			message: String
		},

		computed: {
			config() {
				switch(this.type) {
					case 'network':
						return {
							icon: require('@/assets/image/empty/network.png'),
							message: this.message || '当前服务不可用，请稍后重试'
						}
					
					default:
						return {
							icon: require('@/assets/image/empty/common.png'),
							message: this.message || '未查询到相关数据'
						}
				}
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-empty {
		height: 70vh;
		
		&-icon {
			width: 2.7rem;
			height: 2.7rem;
		}

		&-message {
			margin-top: .3rem;
			line-height: .72rem;
			font-size: .28rem;
			color: #818181;
			
			elder({
				line-height: 1.2rem,
				font-size: .56rem
			})
		}
	}
</style>
